import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchDailyRouteLeadingCount = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'postDailyRouteLeadingCount',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
    impcFromList: payload.params.impcFromList,
    impcToList: payload.params.impcToList,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
  });
};

export default apiFetchDailyRouteLeadingCount;
